export const loadingReducer = (loading: boolean) => (
  acc: {},
  analyticType: AnalyticTypeOption
) => ({
  ...acc,
  [analyticType]: loading,
});
